import { iots } from '@code-expert/prelude';
import { CourseUrl, SemesterId } from '/imports/domain';
import { end, formatRoute, lit, query, type, url } from '/imports/modules/Routing';

export const enroledSlug = 'enrolled';

const enroled = lit(enroledSlug);
const semester = type('semester', SemesterId);
const courseUrl = type('courseUrl', CourseUrl);

export const pageKeys = {
  analytics: null,
  codeExamples: null,
  exercises: null,
  groups: null,
};

export const enroledRoute = url(enroled, end);

const base = url(enroled, semester, courseUrl);

export type Page = keyof typeof pageKeys;
const page = (p: Page) => url(base, lit(p));

export const enroledCourseRoute = url(base, end);

const analyticsQuery = query(iots.exact(iots.partial({ highscoreChartSection: iots.string })));

export const enroledAnalyticsRoute = url(page('analytics'), analyticsQuery, end);
export const enroledCodeExamplesRoute = url(page('codeExamples'), end);
export const enroledExercisesRoute = url(page('exercises'), end);
export const enroledGroupsRoute = url(page('groups'), end);

export const enroledAnalyticsLink = formatRoute(enroledAnalyticsRoute);
